export default [
  // 比赛管理
  {
    path: '/contestback/:contestID',
    component: () => import('@/views/pages/contestBack/index'),
    redirect: '/contestback/:contestID/chaptershow',
    children: [
      {
        path: 'chapter',
        component: () => import('@/views/pages/contestBack/chapter/index.vue'),
        redirect: '/contestback/:contestID/chapter',
        children: [
          {
            path: 'create',
            name: 'create',
            meta: { title: "赛题管理" },
            component: () => import('@/views/pages/contestBack/chapter/chapter.vue'),
          },
          {
            path: '',
            name: 'chapter',
            meta: { title: "赛题管理" },
            component: () => import('@/views/pages/contestBack/chapter/empty.vue')
          },
          {
            path: ':chapterID/section/create',
            name: 'create',
            meta: { title: "赛题管理" },
            component: () => import('@/views/pages/courseBack/section/index.vue')
          },
          {
            path: ':chapterID/section/:sectionID',
            name: 'chapter',
            meta: { title: "赛题管理" },
            component: () => import('@/views/pages/courseBack/section/index.vue')
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "赛题管理" },
            component: () => import('@/views/pages/contestBack/chapter/chapter.vue')
          }
        ]
      }, {
        path: 'chaptershow',
        component: () => import('@/views/pages/contestBack/chapter_show/index.vue'),
        redirect: '/chaptershow/:contestID/chapter',
        children: [
          {
            path: '',
            name: 'chaptershow',
            meta: { title: "赛题预览" },
            component: () => import('@/views/pages/contestBack/chapter_show/empty.vue')
          },
          {
            path: ':chapterID/section/:sectionID',
            name: 'chaptershow',
            meta: { title: "赛题预览" },
            component: () => import('@/views/pages/contestBack/section/index.vue')
          },
          {
            path: ':chapterID',
            name: 'chaptershow',
            meta: { title: "赛题预览" },
            component: () => import('@/views/pages/contestBack/chapter_show/chapter.vue')
          }
        ]
      }, {
        path: 'member',
        name: 'member',
        meta: { title: "成员管理" },
        component: () => import('@/views/pages/contestBack/member/index.vue')
      }, {
        path: 'student',
        name: 'student',
        meta: { title: "选手管理" },
        component: () => import('@/views/pages/contestBack/student/index.vue')
      }, {
        path: 'notifications',
        name: 'notifications',
        meta: { title: "公告发布" },
        component: () => import('@/views/pages/contestBack/notifications/index.vue')
      }, {
        path: 'setting',
        name: 'setting',
        meta: { title: "比赛设置" },
        component: () => import('@/views/pages/contestBack/setting/index.vue')
      }, {
        path: 'rank',
        name: 'rank',
        meta: { title: "排行榜单" },
        component: () => import('@/views/pages/contestBack/rank/index.vue')
      }, {
        path: 'statistic',
        name: 'statistic',
        meta: { title: "数据统计" },
        component: () => import('@/views/pages/courseBack/statistic/index.vue'),
        redirect: '/courseback/:courseID/statistic',
        children: [
          {
            path: '',
            name: 'chapters',
            meta: { title: "课程管理" },
            component: () => import('@/views/pages/courseBack/chapter/empty.vue'),
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "课程管理" },
            component: () => import('@/views/pages/courseBack/statistic/chapter.vue'),
          },
          {
            path: ':chapterID/:sectionID',
            name: 'section',
            meta: { title: "课程管理" },
            component: () => import('@/views/pages/courseBack/statistic/section.vue'),
          },
          {
            path: ':chapterID/:sectionID/:userID',
            name: 'user',
            meta: { title: "课程管理" },
            component: () => import('@/views/pages/courseBack/statistic/user.vue'),
          }
        ]
      }, {
        path: 'chat',
        meta: { title: "聊天管理" },
        component: () => import('@/views/pages/courseBack/chat/index.vue'),
        redirect: '/contestback/:courseID/chat',
        children: [
          {
            path: '',
            name: 'empty',
            meta: { title: "聊天管理" },
            component: () => import('@/views/pages/courseBack/chat/empty.vue'),
          },
          {
            path: ':userID',
            name: 'student',
            meta: { title: "聊天管理" },
            component: () => import('@/views/pages/courseBack/chat/student.vue'),
          }
        ]
      }
    ]
  }
]